module.exports = __webpack_public_path__ + "img/iq_logo.85fe0010.jpg";